export const callQueue = (fn: (s: string) => void, interval = 500) => {
  const queue: string[] = [];
  let running = false;

  return (s: string) => {
    queue.push(s);
    if (!running) {
      running = true;
      const timeout = setInterval(() => {
        const next = queue.shift();
        if (!next) {
          clearInterval(timeout);
          running = false;
          return;
        }
        fn(next);
      }, interval);
    }
  };
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/callQueue.ts